let now = Date.now();
const listeners = new Set<() => void>();
let intervalId: number | null = null;

function start() {
  if (intervalId !== null) return;
  if (typeof window === "undefined") return;

  intervalId = window.setInterval(() => {
    now = Date.now();
    for (const listener of listeners) listener();
  }, 60_000);
}

function stop() {
  if (intervalId === null) return;
  clearInterval(intervalId);
  intervalId = null;
}

export function subscribeNow(listener: () => void) {
  listeners.add(listener);
  start();

  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) stop();
  };
}

export function getNowSnapshot() {
  return now;
}

export function getNowServerSnapshot() {
  return now;
}

